import { FacebookLogo, InstagramLogo, ThreadsLogo, TiktokLogo, PinterestLogo, WhatsappLogo, MapPin } from "@phosphor-icons/react";
import { SOCIALS } from "@/data/site";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";
import { Logo } from "@/components/Logo";

const SOCIAL_ICONS = { Facebook: FacebookLogo, Instagram: InstagramLogo, Threads: ThreadsLogo, TikTok: TiktokLogo, Pinterest: PinterestLogo };

const PAGE_LINKS = [
  { label: "Equipamiento", href: "/#equipamiento" },
  { label: "Nosotros", href: "/nosotros" },
  { label: "Opiniones", href: "/#voces" },
  { label: "Blog", href: "/blog" },
  { label: "Contacto", href: "/contacto" },
];

const HELP_LINKS = [
  { label: "Garantías", href: "/#compra-segura" },
  { label: "Rastrear mi pedido", href: "/rastreo" },
  { label: "Cambios y devoluciones", href: "/devoluciones" },
  { label: "Términos y condiciones", href: "/terminos" },
  { label: "Aviso de privacidad", href: "/privacidad" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (href) => {
    if (href.startsWith("/#")) {
      const id = href.slice(2);
      if (location.pathname !== "/") navigate(href);
      scrollToSection(id);
      return;
    }
    navigate(href);
  };

  const linkBtn = (link) => (
    <button
      key={link.href}
      data-testid={`footer-nav-${link.href.replace(/[/#]/g, "")}`}
      onClick={() => go(link.href)}
      className="text-[15px] text-left text-white/60 hover:text-white transition-colors duration-300"
    >
      {link.label}
    </button>
  );

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-5 gap-10 md:gap-8 items-start text-left">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <Logo className="h-10 w-10 rounded-full object-cover" />
            <span className="font-display text-2xl font-semibold uppercase tracking-wide text-white">
              Ruta<span className="text-[#FF5508]">360</span>
            </span>
          </div>
          <p className="text-white/40 text-[15px]">Explora. Supera. Conecta.</p>
        </div>

        <div>
          <p className="text-base font-semibold text-white mb-4">Página</p>
          <nav className="flex flex-col gap-3 items-start">
            {PAGE_LINKS.map(linkBtn)}
          </nav>
        </div>

        <div>
          <p className="text-base font-semibold text-white mb-4">Ayuda</p>
          <nav className="flex flex-col gap-3 items-start">
            {HELP_LINKS.map(linkBtn)}
          </nav>
        </div>

        <div>
          <p className="text-base font-semibold text-white mb-4">Contacto</p>
          <div className="flex flex-col gap-3 items-start">
            <a
              data-testid="footer-whatsapp-link"
              href="https://wa.me/5212284081782"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[15px] text-white/60 hover:text-white transition-colors duration-300"
            >
              <WhatsappLogo size={16} weight="fill" className="text-[#FF5508]" /> +52 1 228 408 1782
            </a>
            <span className="inline-flex items-start gap-2 text-[15px] text-white/60">
              <MapPin size={16} weight="fill" className="text-[#FF5508] shrink-0 mt-0.5" />
              Punto de distribución: Xalapa, Veracruz, México
            </span>
          </div>
        </div>

        <div>
          <p className="text-base font-semibold text-white mb-4">Síguenos</p>
          <div data-testid="footer-socials" className="flex flex-wrap gap-3">
            {SOCIALS.map((s) => {
              const Icon = SOCIAL_ICONS[s.label];
              return (
                <a
                  key={s.label}
                  data-testid={`footer-${s.testid}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/50 transition-colors duration-300 hover:bg-white hover:text-black hover:border-white"
                >
                  <Icon size={17} weight="fill" />
                </a>
              );
            })}
          </div>
          <p className="text-xs font-semibold text-white/40 mt-6 mb-2">Pagos seguros</p>
          <div className="flex flex-wrap gap-2">
            <span className="text-xs text-white/70 border border-white/20 rounded-full px-3.5 py-1.5">Mercado Pago</span>
            <span className="text-xs text-white/70 border border-white/20 rounded-full px-3.5 py-1.5">PayPal</span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10 pt-8 border-t border-white/10">
        <p className="text-sm text-white/30">
          © 2026 Ruta 360 | Envíos a todo México
        </p>
      </div>
    </footer>
  );
};
